@if (authService.hasPermission(Permission.ProductReceivalsFull)) {
  <button
    mat-menu-item
    (click)="onOpenReceivals()"
    >
    <mat-icon>list</mat-icon>
    <span>Receivals</span>
  </button>
}
